import {
  IconArrowRight,
  IconCircleCheckFilled,
  IconPlus,
} from "@tabler/icons-react";
import React, { useRef, useEffect } from "react";
import {
  DoorDashLogoSm,
  EzCaterLogoSm,
  GrubHubLogoSm,
  UberEatsLogoSm,
  ToastLogoSm,
  OloLogoSm,
  QuickBooksLogoSm,
  R365LogoSm,
  NovaDineLogoSm,
  XeroLogoSm
} from "../../view/FinanceReco";
import VooshLogo from "../../assets/images/VooshLogo.webp";
import LeaderLine from "leader-line-new";
import { motion } from "framer-motion";
import { container, item } from "../homepage/Section1";
import { Link } from "react-router-dom";

const Section1 = () => {
  const lines = useRef([]);

  useEffect(() => {
    const divA = document.getElementById("divA");
    const divB = document.getElementById("divB");
    const divC = document.getElementById("divC");
    const divD = document.getElementById("divD");

    if (divA && divB && divC && divD) {
      lines.current = [
        new LeaderLine(divA, divC, {
          color: "#ffffff80",
          dash: { animation: true },
          endPlug: "arrow1",
          path: "straight",
        }),
        new LeaderLine(divB, divC, {
          color: "#ffffff80",
          dash: { animation: true },
          endPlug: "arrow1",
          path: "fluid",
        }),
        new LeaderLine(
          LeaderLine.pointAnchor(divC, { x: "100%", y: "40%" }),
          LeaderLine.pointAnchor(divD, { x: "0%", y: "40%" }),
          {
            color: "#ffffff80",
            size: 2,
            endPlug: "arrow3",
            startPlug: "disc",
            path: "straight",
            startLabel: LeaderLine.pathLabel({
              text: "AUTOMATE",
              color: "#fff",
              fontSize: 10,
              outlineColor: "transparent",
            }),
            dash: { animation: true },
          }
        ),
        new LeaderLine(
          LeaderLine.pointAnchor(divD, { x: "0%", y: "60%" }),
          LeaderLine.pointAnchor(divC, { x: "100%", y: "60%" }),
          {
            color: "#ffffff80",
            size: 2,
            endPlug: "arrow3",
            startPlug: "disc",
            path: "straight",
            startLabel: LeaderLine.pathLabel({
              text: "DATA SHARING",
              color: "#fff",
              fontSize: 10,
              outlineColor: "transparent",
              orientation: "horizontal",
            }),
            dash: { animation: true },
            rotate: "fixed",
          }
        ),
      ];
    }

    return () => {
      lines.current.forEach((line) => line.remove());
    };
  }, []);

  return (
    <div className="s1-container fin-reco-container">
      <div className="bg-grid">
        <div className="f-width m-auto">
          <motion.div
            variants={container}
            whileInView="visible"
            initial="hidden"
            className="hero-data text-center"
          >
            <p className="fs-lg text-white">Voosh Financial Reconciliation</p>
            <p className="fs-sm txt-offwhite px-4">
              Restaurants lose thousands of dollars each month because of payout
              discrepancies, hidden charges, missed revenue, and inefficient
              manual accounting. Without accurate reconciliation, profits and
              operational efficiency suffer. Voosh solves these problems,
              automating your financial reconciliation and ensuring you're never
              leaving revenue behind.
            </p>
            <Link
              to={
                "https://meetings.hubspot.com/bilal-k-s/meeting-with-bilal&__hstc=181257784.c6a9d1b3be4a6fd2ed9c2295680beb42.1703009108941.1746007643280.1746038291275.298&__hssc=181257784.7.1746038291275&__hsfp=1658680018"
              }
            >
              <div className="btn brand-bg text-white rounded-pill shadow">
                Start My Financial Fix <IconArrowRight className="btn-arr" />
              </div>
            </Link>
          </motion.div>
          <div className="fin-graph-hero">
            <div
              id="divA"
              className="logo-container rounded-pill align-content-around m-auto"
              style={{ backgroundColor: "#ffffff20" }}
            >
              <div className="bg-white rounded-pill text-center m-auto pill-p">
                <p className="fs-12px mb-0 text-success">
                  <IconCircleCheckFilled className="icon-vsm" /> Third Party
                  Platforms
                </p>
              </div>
              <motion.div
                variants={container}
                whileInView="visible"
                initial="hidden"
                className="d-flex align-items-center justify-content-evenly"
              >
                <motion.div
                  variants={item}
                  whileInView="visible"
                  initial="hidden"
                  className="img-wrap"
                >
                  <img src={UberEatsLogoSm} alt="Uber Eats Logo" />
                </motion.div>
                <motion.div
                  variants={item}
                  whileInView="visible"
                  initial="hidden"
                  className="img-wrap"
                >
                  <img src={DoorDashLogoSm} alt="Door dash logo" />
                </motion.div>
                <motion.div
                  variants={item}
                  whileInView="visible"
                  initial="hidden"
                  className="img-wrap"
                >
                  <img src={GrubHubLogoSm} alt="Grubhub logo" />
                </motion.div>
                <motion.div
                  variants={item}
                  whileInView="visible"
                  initial="hidden"
                  className="img-wrap"
                >
                  <img src={EzCaterLogoSm} alt="EzCater logo" />
                </motion.div>
              </motion.div>
            </div>
            <div className="d-flex mt-5 logo-container-2nd-row">
              <div
                id="divB"
                className="logo-container rounded-pill align-content-around m-auto lc-left"
                style={{ backgroundColor: "#ffffff20" }}
              >
                <div className="bg-white rounded-pill text-center m-auto pill-p">
                  <p className="fs-12px mb-0 text-success">
                    <IconCircleCheckFilled className="icon-vsm" /> POS
                    Integrations
                  </p>
                </div>
                <motion.div
                  variants={container}
                  whileInView="visible"
                  initial="hidden"
                  className="d-flex align-items-center justify-content-evenly"
                >
                  <motion.div
                    variants={item}
                    whileInView="visible"
                    initial="hidden"
                    className="img-wrap"
                  >
                    <img src={ToastLogoSm} alt="Toast Logo" />
                  </motion.div>
                  <motion.div
                    variants={item}
                    whileInView="visible"
                    initial="hidden"
                    className="img-wrap"
                  >
                    <img src={OloLogoSm} alt="Olo logo" />
                  </motion.div>
                  <motion.div
                    variants={item}
                    whileInView="visible"
                    initial="hidden"
                    className="img-wrap"
                  >
                    <img src={NovaDineLogoSm} alt="Novadine logo" />
                  </motion.div>
                  <motion.div
                    variants={item}
                    whileInView="visible"
                    initial="hidden"
                    className="img-wrap"
                  >
                    <IconPlus
                      className="icon-vsm"
                      style={{ color: "#00000050" }}
                    />
                  </motion.div>
                </motion.div>
              </div>
              <div
                id="divC"
                className="logo-container rounded-pill align-content-around m-auto lc-center"
                style={{ backgroundColor: "#ffffff20" }}
              >
                <div className="d-flex align-items-center justify-content-evenly">
                  <motion.img
                    variants={item}
                    whileInView="visible"
                    initial="hidden"
                    src={VooshLogo}
                    style={{ width: "150px" }}
                    className="b-logo-vsm"
                    alt="Voosh Brand Logo"
                  />
                </div>
              </div>
              <div
                id="divD"
                className="logo-container rounded-pill align-content-around m-auto lc-right"
                style={{ backgroundColor: "#ffffff20" }}
              >
                <div className="bg-white rounded-pill text-center m-auto pill-p">
                  <p className="fs-12px mb-0 text-success">
                    <IconCircleCheckFilled className="icon-vsm" /> Accounting
                    Software
                  </p>
                </div>
                <motion.div
                  variants={item}
                  whileInView="visible"
                  initial="hidden"
                  className="d-flex align-items-center justify-content-evenly"
                >
                  <motion.div
                    variants={item}
                    whileInView="visible"
                    initial="hidden"
                    className="img-wrap"
                  >
                    <img src={QuickBooksLogoSm} alt="Quick books Logo" />
                  </motion.div>
                  <motion.div
                    variants={item}
                    whileInView="visible"
                    initial="hidden"
                    className="img-wrap"
                  >
                    <img src={R365LogoSm} alt="R365 logo" />
                  </motion.div>
                  <motion.div
                    variants={item}
                    whileInView="visible"
                    initial="hidden"
                    className="img-wrap"
                  >
                    <img src={XeroLogoSm} alt="Xero logo" />
                  </motion.div>
                  <motion.div
                    variants={item}
                    whileInView="visible"
                    initial="hidden"
                    className="img-wrap"
                  >
                    <IconPlus
                      className="icon-vsm"
                      style={{ color: "#00000050" }}
                    />
                  </motion.div>
                </motion.div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section1;
